import { render, staticRenderFns } from "./put.vue?vue&type=template&id=bf842dda&scoped=true"
import script from "./put.vue?vue&type=script&lang=js"
export * from "./put.vue?vue&type=script&lang=js"
import style0 from "./put.vue?vue&type=style&index=0&id=bf842dda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf842dda",
  null
  
)

export default component.exports